import React, {useState, useMemo, use, createContext} from "react";
import PropTypes from "prop-types";
import {responsiveFontSizes, ThemeProvider} from "@mui/material/styles";
import {CacheProvider} from "@emotion/react";
import {TssCacheProvider} from "tss-react";
import createCache from "@emotion/cache";
import {toggleTheme, initializeTheme, themeMap} from "./theme";

export const ThemeWrapperContext = createContext(null);

const muiCache = createCache({key: "mui", prepend: true});
const tssCache = createCache({key: "tss"});

export const ConsolidatedThemeProvider = ({children, themeName}) => {
  const [activeTheme, setActiveTheme] = useState(initializeTheme());

  const currentTheme = themeName && themeMap[themeName] ? themeMap[themeName] : activeTheme;

  const toggleActiveTheme = useMemo(() => (name) => toggleTheme({setActiveTheme}, name), []);

  return (
    <CacheProvider value={muiCache}>
      <TssCacheProvider value={tssCache}>
        <ThemeWrapperContext value={{activeTheme: currentTheme, setActiveTheme, toggleActiveTheme}}>
          <ThemeProvider theme={responsiveFontSizes(currentTheme)}>{children}</ThemeProvider>
        </ThemeWrapperContext>
      </TssCacheProvider>
    </CacheProvider>
  );
};

ConsolidatedThemeProvider.propTypes = {
  children: PropTypes.any,
  themeName: PropTypes.string,
};

export const useTheme = () => {
  return use(ThemeWrapperContext);
};
